module.exports = __webpack_public_path__ + "img/search-icon.c9a3def5.svg";